<k-cards [size]="size" [isResponsive]="isResponsive" class="relative" [highlightOnHover]="highlightOnHover">
    <div class=" card-content h-full w-full" (click)="click()">
        <div class="pic-container">
            <img class="" [ngClass]="[
                data.status==0?'egg':'pic',
            disableIfNotBreedableYet && timeToBreed>currentDate ? 'grayscale':'']" [src]="pic" />
        </div>

        <div class="footer">
            <div class="flex-wrapper">
                <div *ngIf="!data.name" class="title">ID: {{data.tokenId}}</div>
                <div *ngIf="data.name" class="title">{{data.name}}</div>
                <div class="gradient-label" *ngIf="isPriceVisible">
                    <span>
                        ${{_dollarAmount}}
                    </span>
                </div>
            </div>
            <div class="flex-wrapper">
                <rank [ranking]="data.ranking" [shape]="rankShape" [size]="rankSize"></rank>
                <div class="flex" *ngIf="isPriceVisible">
                    <div class="currency-icon mr-1" *ngIf="_kmonPrice">
                        <img src="./assets/img/Icon/Cur-Kmon.png">
                    </div>

                    <div class="sm-amount">
                        {{_kmonPrice}}
                    </div>
                </div>
            </div>
            <div class="flex-wrapper description">
                Speciality: {{data.speciality}}
            </div>
            <div class="flex-wrapper-start">
                <info-icon *ngIf="data.isStarter" [settings]="{type:'syntetic'}"></info-icon>
                <info-icon [settings]="_elementTypeSettings"></info-icon>
                <info-icon [settings]="_elementTypeSecondSettings"></info-icon>
                <info-icon [settings]="_breedingCount" *ngIf="isBreedingVisible"></info-icon>
                <info-icon [settings]="_gender"></info-icon>
                <info-icon [settings]="_generation"></info-icon>

            </div>

        </div>
        <ng-container *ngIf="disableIfNotBreedableYet && timeToBreed>currentDate">
            <ng-container *transloco="let t;">
                <div class="absolute top-1/3 w-full bg-k-gray-disabled text-sm sm:text-base rounded-2xl px-6 box-shadow-big flex flex-col flex-nowrap items-center font-space leading-5 place-content-center"
                    countdown [endDate]="timeToBreed">
                    <span>{{t('kryptomons.countdownNextBreed')}}</span>
                    <div class="flex flex-row items-center">
                        <span>{{t('date.days')}}: </span>
                        <span class="mr-1 font-bold" id="days"></span>
                        <span>{{t('date.hours')}}: </span>
                        <span class="mr-1 font-bold" id="hours"></span>
                        <span>{{t('date.minutes')}}: </span>
                        <span class="mr-1 font-bold" id="minutes"></span>
                    </div>
                </div>
            </ng-container>
        </ng-container>
    </div>
</k-cards>